<template>
  <div class="app-container">
    <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" :model="searchForm" ref="searchForm" class="demo-form" label-width="80px" size="mini">
        <div class="">
          <el-form-item label="年月:">
            <el-date-picker
              v-model="searchForm.yearMonthDate"
              type="month"
              format="yyyy-MM"
              value-format="yyyy-MM"
              placeholder="请选择">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="编制时间:">
            <el-date-picker
              v-model="searchForm.createTimes"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              :default-time="['00:00:00', '23:59:59']"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="状态:">
            <el-select v-model="searchForm.planStatus" placeholder="请选择">
              <el-option label="全部" value="" ></el-option>
              <el-option label="待编写" value="0" ></el-option>
              <el-option label="待提交" value="1" ></el-option>
              <el-option label="待审核" value="2" ></el-option>
              <el-option label="审核驳回" value="3" ></el-option>
              <el-option label="审核通过" value="4" ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="searchBtnBox">
          <el-form-item>
            <el-button type="primary" class="allBtn" @click="searchFn" v-if="btnFlg[0]">查询</el-button>
            <el-button type="primary" class="allBtn" @click="resetForm('searchForm')">重置</el-button>
            <el-button type="primary" class="allBtn" @click="addMaterial" v-if="btnFlg[1]">新增</el-button>
             <el-button type="primary" class="allBtn" @click="modelDown" v-if="btnFlg[11]">模板下载</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{ height: h }">
      <el-table :data="tableList" ref="table" bordersize="mini" height="100%" style="width: 100%" class="tableComent" @selection-change="handleSelectionChange" @row-click="rowClick" highlight-current-row center border>
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
        <el-table-column width="130" label="操作">
          <template slot-scope="scope">
            <div>
              <span style="display: inline-block;margin-left: 8px;" v-if="orgSubCode==scope.row.createSubdepartmentCode">
                <el-button type="text" size="mini" @click="editWeekFn(scope.row)" v-if="(scope.row.planStatus == '1' || scope.row.planStatus == '3') && btnFlg[2]">修改</el-button>
                <el-button type="text" size="mini" @click="tiJiaoSHFn(scope.row)" v-if="scope.row.planStatus == '1' && btnFlg[5]">提交</el-button>
                <el-button type="text" size="mini" @click="shenHeFn(scope.row)" v-if="scope.row.planStatus == '2' &&userName==scope.row.auditUserName && btnFlg[6]">审核</el-button>
                <el-button type="text" size="mini" @click="delMaterial(scope.row)" v-if="(scope.row.planStatus == '0' || scope.row.planStatus == '1' || scope.row.planStatus == '3') && btnFlg[3]">删除</el-button>
                <el-button type="text" size="mini" @click="bianXieFn(scope.row)" v-if="scope.row.planStatus == '0' && btnFlg[4]">编写</el-button>
                <el-button type="text" size="mini" v-if="scope.row.planStatus=='4' && btnFlg[9]" @click="chexiaoFn(scope.row)" >撤销</el-button>
                <el-button type="text"  v-if="(scope.row.planStatus == '1' || scope.row.planStatus == '3'||scope.row.planStatus == '0' )&& btnFlg[11]"  @click="importFn(scope.row)" size="mini" >导入</el-button>
                <el-button type="text" size="mini" v-if="btnFlg[10]" @click="delFn(scope.row)" >强制删除</el-button>
              </span>
              <el-button type="text" size="mini" @click="weekPlanFn(scope.row)" v-if="btnFlg[7]">周计划</el-button>
              <el-button type="text" size="mini" v-if="scope.row.planStatus!='0' && btnFlg[8]" @click="daochuFn(scope.row)" :disabled='isDisable'>导出详情</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="createDepartmentName" width="90" label="部门" show-overflow-tooltip></el-table-column>
        <el-table-column prop="planStatus" width="80" label="状态">
          <template scope="scope">
            <div>
              <!-- 0：待编写 1：待提交 2：待审核（审核中） 3：审核驳回 4：审核通过 -->
              <span style="color: #D51212;" v-if="scope.row.planStatus==0">待编写</span>
              <span style="color: #E99D42;" v-if="scope.row.planStatus==1">待提交</span>
              <span style="color: #03aadf;" v-if="scope.row.planStatus==2">待审核</span>
              <span style="color: #f52020;" v-if="scope.row.planStatus==3">审核驳回</span>
              <span style="color: #81B337;" v-if="scope.row.planStatus==4">审核通过</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="monthSubmitPlanDate" width="170" label="最晚提交时间" :formatter="dateTimeFormat"></el-table-column>
        <el-table-column prop="yearMonthDate" width="80" label="月份">
          <template slot-scope="scope">
            <div>
              <el-button type="text" size="mini" @click="detailWeekFn(scope.row)">{{ scope.row.yearMonthDate }}</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="predictedIncome" width="80" label="计划收入(万元)"></el-table-column>
        <el-table-column prop="cwAdjustmentIncome" width="90" label="调整后收入(万元)"></el-table-column>
        <el-table-column prop="predictedExpense" width="90" label="计划支出(万元)"></el-table-column>
        <el-table-column prop="cwAdjustmentExpense" width="90" label="调整后支出(万元)"></el-table-column>
        <el-table-column prop="incomeExpenditureDifference" width="80" label="收支差异(万元)">
          <template slot="header">
            <el-tooltip
              class="item"
              effect="dark"
              content="收支差异 = 计划收入-计划支出"
              placement="top"
            >
              <span>收支差异(万元) <i class="el-icon-info"></i></span>
            </el-tooltip>
          </template>
          <!-- <template scope="scope">
            <div>
              {{toFixed(scope.row.predictedIncome-scope.row.predictedExpense,2)}}
            </div>
          </template>  -->
        </el-table-column>
        <el-table-column prop="actualIncome" width="80" label="实际收入(万元)"></el-table-column>
        <el-table-column prop="actualExpense" width="80" label="实际支出(万元)"></el-table-column>
        <el-table-column prop="" width="75" label="现金流(万元)">
           <template slot="header">
            <el-tooltip
              class="item"
              effect="dark"
              content="现金流 = 实际收入-实际支出"
              placement="top"
            >
              <span>现金流(万元) <i class="el-icon-info"></i></span>
            </el-tooltip>
          </template>
          <template scope="scope">
            <div>
             {{toFixed(scope.row.actualIncome-scope.row.actualExpense,4)}}
            </div>
          </template>
        </el-table-column>
        <el-table-column width="100" label="收入偏差金额(万元)">
          <template slot="header">
            <el-tooltip
              class="item"
              effect="dark"
              content="收入偏差金额 = 实际收入 - 计划收入"
              placement="top"
            >
              <span>收入偏差金额(万元) <i class="el-icon-info"></i></span>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <span>{{ scope.row.incomeDisparity }}</span>
          </template>
        </el-table-column>
        <el-table-column width="100" label="收入偏差率(%)">
          <template slot="header">
            <el-tooltip
              class="item"
              effect="dark"
              content="收入偏差率 = (收入偏差金额/计划收入*100%)"
              placement="top"
            >
              <span>收入偏差率(%) <i class="el-icon-info"></i></span>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <span>{{ scope.row.incomeDisparityRate }}%</span>
          </template>
        </el-table-column>
        <el-table-column width="100" label="支出偏差金额(万元)">
          <template slot="header">
            <el-tooltip
              class="item"
              effect="dark"
              content="支出偏差金额 = 实际支出 - 计划支出"
              placement="top"
            >
              <span>支出偏差金额(万元) <i class="el-icon-info"></i></span>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <span>{{ scope.row.expenditureDisparity }}</span>
          </template>
        </el-table-column>
        <el-table-column width="125" label="支出偏差率(%)">
          <template slot="header">
            <el-tooltip
              class="item"
              effect="dark"
              content="支出偏差率 = (支出偏差金额/计划支出*100%)"
              placement="top"
            >
              <span>支出偏差率(%) <i class="el-icon-info"></i></span>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <span>{{ scope.row.expenditureDisparityRate }}%</span>
          </template>
        </el-table-column>
        <el-table-column prop="createUser" width="100" label="编制人"></el-table-column>
        <el-table-column prop="createTime" width="160" label="编制时间" :formatter="dateTimeFormat"></el-table-column>
        <el-table-column prop="auditTime" width="160" label="审核时间" :formatter="dateTimeFormat"></el-table-column>
        <el-table-column prop="auditUserName" width="100" label="审核人" :formatter="emptyFn"></el-table-column>
        <el-table-column prop="auditRemark" width="100" label="审核备注" show-overflow-tooltip :formatter="emptyFn"></el-table-column>
        <el-table-column prop="tenantFaction" width="80" label="所属系别">
          <template scope="scope">
            <div>
              <span  v-if="scope.row.tenantFaction==0">中物系</span>
              <span  v-if="scope.row.tenantFaction==1">兴瀚系</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页-->
    <div>
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="searchForm.pageNo" :page-sizes="[10, 20, 25, 50, 100]" :page-size="searchForm.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
    <!-- 新增资金计划周期 -->
    <el-dialog title="新增资金计划" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="dialogVisible" @close="close" center width="500px">
      <el-form :rules="rules" :model="addForm" :validate-on-rule-change="false" ref="addForm" class="demo-form-inline" label-width="150px" :inline="false" size="small" v-if="dialogVisible">
        <div class="addinpBox">
          <el-form-item label="年月:" prop="yearMonthDate">
            <el-date-picker
              v-model="addForm.yearMonthDate"
              format="yyyy-MM"
              value-format="yyyy-MM"
              type="month"
              placeholder="请选择">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="所属系别:"  prop="tenantFaction">
            <el-select v-model="addForm.tenantFaction" placeholder="请选择">
              <el-option label="中物系" value="0" ></el-option>
              <el-option label="兴瀚系" value="1" ></el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="saveFn" :loading="addLoading">保 存</el-button>
        <el-button @click="close" size="mini">取 消</el-button>
      </span>
    </el-dialog>
    <monthPlanDialog v-if="dialogMonth" :dialogMonth.sync="dialogMonth" :rowData="rowData" :title="xzTitle" :isAdd="isAdd"></monthPlanDialog>
    <!-- 审核 -->
    <monthShenHe v-if="dialogShenHe" :dialogShenHe.sync="dialogShenHe" :rowData="rowData" :title="xzTitle"></monthShenHe>
    <monthDetail v-if="dialogDetail" :dialogDetail.sync="dialogDetail" :rowData="rowData" :title="xzTitle"></monthDetail>
        <!-- 导入 -->
<importC   v-if="importDialog" danwei="M" size="5" @DRsave="DRsave" @destroy="destroy"></importC>
  </div>
</template>
<script>
import { getBtn } from '@/utils/getButton'
import { masterList, addMonthlyFundPlanMaster, delMonthlyFundPlanMaster, monthlySubmitForReview, monthlyReviewRevoke, delMonthlyFundPlan, imporMonthlyFundPlanDetail } from '@/api/common-signature'
import { dateFormat1, dateTimeFormat, emptyFn, toFixed } from '@/utils/util'
import monthPlanDialog from '@/views/common-signature/fundingPlan/public/monthPlanDialog.vue'
import monthShenHe from '@/views/common-signature/fundingPlan/public/monthShenHe.vue'
import monthDetail from '@/views/common-signature/fundingPlan/public/monthDetail.vue'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import importC from '@/components/import1.vue'
export default {
  name: 'BasicMeterial',
  components: { monthPlanDialog, monthShenHe, monthDetail, importC },
  data () {
    return {
      toFixed: toFixed,
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      searchForm: {
        pageNo: 1,
        pageSize: 50
      },
      addForm: {},
      title: '',
      tableList: [],
      total: 0,
      dialogVisible: false,
      rules: {
        yearMonthDate: [
          { required: true, message: '请选择年月', trigger: 'change' }
        ],
        tenantFaction: [
          { required: true, message: '请选择系别', trigger: 'change' }
        ]
      },
      addLoading: false,
      selectRows: [],
      selectRowsInfo: [],
      // 按钮
      btnFlg: [],
      btnIdArr: [
        '00FM0Q0100',
        '00FM0Q0200',
        '00FM0Q0300',
        '00FM0Q0400',
        '00FM0Q0500',
        '00FM0Q0600',
        '00FM0Q0700',
        '00FM0Q0800',
        '00FM0Q0900', '00FM0Q0A00', '00FM0Q0B00', '00FM0Q0C00'
      ],
      h: '',
      pickerOptions: {
        disabledDate (time) {
        // 获取当前日期
          const now = new Date()
          // 设置到当前月份的第一天（用于比较月份）
          const currentYear = now.getFullYear()
          const currentMonth = now.getMonth()
          const currentFirstDay = new Date(currentYear, currentMonth, 1)

          // 禁用今天之前的月份
          return time.getTime() < currentFirstDay.getTime()
        }
      },
      dialogMonth: false,
      isAdd: false,
      xzTitle: '新增月资金计划',
      rowData: {},
      userName: localStorage.getItem('userName'),
      dialogShenHe: false,
      dialogDetail: false,
      isDisable: false,
      orgSubCode: localStorage.getItem('orgSubCode'),
      importDialog: false

    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/monthlyFundsPlan')
    this.masterList()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 165 + 'px'
    this.searchForm.cycleMasterId = this.$route.query.cycleMasterId
    this.searchForm.createDepartmentCode = this.$route.query.createDepartmentCode
  },
  methods: {
    // 导入
    importFn (row) {
      this.importDialog = true
      this.rowData = row
    },
    // 导入模板下载
    modelDown () {
      var tempwindow = window.open('_blank') // 先打开页面
      tempwindow.location = 'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/tms/excel/%E6%9C%88%E8%B5%84%E9%87%91%E8%AE%A1%E5%88%92%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'// 后更改页面地址
    },
    DRsave (formData) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      formData.append('params', JSON.stringify({ monthlyPlanMasterId: this.rowData.id }))
      imporMonthlyFundPlanDetail(formData).then(res => {
        loading.close()
        this.importDialog = false
        this.msg = this.$message({
          showClose: true,
          message: res,
          duration: 3000,
          type: 'success',
          onClose () {

          }
        })
        this.searchFn()
      }).catch(err => {
        if (err.code == -1) {
          this.$message({
            type: 'warning',
            message: err.data ? err.data : err.message,
            onClose () {
              loading.close()
            }
          })
          this.isDisable = false
        } else if (err.code == 1) {
          this.isDisable = false
          this.$confirm('存在异常信息，是否确认导出异常信息?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            const loading = this.$loading({
              lock: true,
              text: '正在导出异常信息...'
            })
            let form = {}
            exportExcel(
              this.global.smpName +
                    '/monthlyFundPlanMaster/exportMonthlyFundPlanDetailExc',
              form,
              '异常信息表'
            )
            setTimeout(() => {
              this.$message({
                type: 'success',
                message: err.data
              })
              loading.close()
              this.daoRuMark = false
              this.importDialog = false
              this.searchFn()
            }, 3000)
          }).catch(() => {
            this.daoRuMark = false
            this.$message({
              type: 'warning',
              message: '已取消异常信息导出，' + err.data,
              onClose () {
                loading.close()
              }
            })
          })
        } else {
          loading.close()
        }
      })
    },
    destroy () {
      this.importDialog = false
    },
    // 无限制删除
    delFn (row) {
      this.$confirm('是否执行强制删除操作？', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        delMonthlyFundPlan({
          id: row.id
        })
          .then(res => {
            loading.close()
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.masterList()
          })
          .catch(err => {
            this.$message({
              showClose: true,
              message: err.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
      })
    },
    // 撤销
    chexiaoFn  (row) {
      this.$confirm('是否执行撤销操作？', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        monthlyReviewRevoke({
          id: row.id
        })
          .then(res => {
            loading.close()
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.masterList()
          })
          .catch(err => {
            this.$message({
              showClose: true,
              message: err.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
      })
    },
    masterList () {
      if (this.searchForm.createTimes) {
        this.searchForm.startTime = this.searchForm.createTimes[0]
        this.searchForm.endTime = this.searchForm.createTimes[1]
      } else {
        this.searchForm.startTime = ''
        this.searchForm.endTime = ''
      }
      const loading = this.$loading({
        lock: true,
        text: '加载中...'
      })
      masterList(this.searchForm)
        .then(res => {
          console.log(res)
          loading.close()
          // res.list.forEach(item => {
          //   item.createTime = dateFormat1(item.createTime)
          //   item.updateTime = dateFormat1(item.updateTime)
          // })
          this.tableList = res.list
          this.total = res.total
          if (this.$route.query.cycleMasterId && this.$route.query.createDepartmentCode) {
            this.detailWeekFn(res.list[0])
          }
        })
        .catch(err => {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
    },
    searchFn () {
      this.masterList()
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchForm.pageSize = val
      this.masterList()
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchForm.pageNo = val
      this.masterList()
    },
    rowClick (row, col, event) {
      this.selectRows[0] = row
      this.$refs.table.toggleRowSelection(row)
    },
    handleSelectionChange (val) {
      this.selectRows = val.map(item => item.id)
      this.selectRowsInfo = val
    },
    getNextMonth () {
      const date = new Date()
      date.setMonth(date.getMonth() + 1)

      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')

      return `${year}-${month}`
    },
    saveFn () {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          addMonthlyFundPlanMaster(this.addForm)
            .then(res => {
              console.log(res)
              loading.close()
              this.dialogVisible = false
              this.masterList()
              this.initAddForm()
              this.$message.success('添加成功')
            })
            .catch(err => {
              this.addLoading = false
              console.log(err)
              this.$message({
                showClose: true,
                message: err.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
        } else {
          this.addLoading = false
        }
      })
    },
    resetForm () {
      this.searchForm = {
        pageNo: 1,
        pageSize: 50
      }
      this.masterList()
    },
    addMaterial () {
      this.dialogVisible = true
      this.addLoading = false
      this.$set(this.addForm, 'yearMonthDate', this.getNextMonth())
      this.$nextTick(() => {
        this.$refs['addForm'].clearValidate()
      })
      // this.saveFn()
    },
    initAddForm () {
      this.addForm = {}
    },
    close () {
      this.dialogVisible = false
      this.initAddForm()
    },
    delMaterial (row) {
      this.$confirm('是否执行删除操作？', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        delMonthlyFundPlan({
          id: row.id
        })
          .then(res => {
            loading.close()
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.masterList()
          })
          .catch(err => {
            this.$message({
              showClose: true,
              message: err.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
      })
    },
    bianXieFn (row) {
      if (new Date().getTime() > row.monthSubmitPlanDate) {
        this.$message.error('编辑时间不能晚于最晚提交时间')
        return
      }
      this.dialogMonth = true
      this.xzTitle = '新增月资金计划'
      this.isAdd = true
      this.rowData = row
    },
    editWeekFn (row) {
      if (new Date().getTime() > row.monthSubmitPlanDate) {
        this.$message.error('编辑时间不能晚于最晚提交时间')
        return
      }
      this.dialogMonth = true
      this.xzTitle = '修改月资金计划'
      this.isAdd = false
      this.rowData = row
    },
    tiJiaoSHFn (row) {
      if (new Date().getTime() > row.monthSubmitPlanDate) {
        this.$message.error('提交时间不能晚于最晚提交时间')
        return
      }
      this.$confirm('是否执行提交操作？', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        monthlySubmitForReview({
          id: row.id
        })
          .then(res => {
            loading.close()
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.masterList()
          })
          .catch(err => {
            this.$message({
              showClose: true,
              message: err.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
      })
    },
    shenHeFn (row) {
      this.dialogShenHe = true
      this.xzTitle = '审核'
      this.rowData = row
    },
    weekPlanFn (row) {
      this.$router.push({ name: 'weeklyFundPlan', query: { rowId: row.id } })
    },
    detailWeekFn (row) {
      this.dialogDetail = true
      this.xzTitle = '详情'
      this.rowData = row
    },
    async daochuFn (row) {
      this.isDisable = true

      let form = {
        cycleMasterId: row.cycleMasterId, // 资金计划周期表id
        monthlyPlanMasterId: row.id // 月资金计划主表id
      }
      await exportExcel(
        this.global.smpName + '/monthlyFundPlanMaster/exportDetailList',
        form,
        '周月资金计划明细'
      )
      this.isDisable = false
    }
  }
}
</script>

<style scoped lang="less">
.searchBtnBox {
  margin-left: 10px;
}
.addinpBox .el-input {
  width: 210px;
}
.demo-form-inline .el-select {
  width: 210px;
}
/deep/.el-input.is-disabled .el-input__inner{
  color: #333 !important;
}
</style>
